export default "__VITE_ASSET__CQaxSfES__"